export const openTab = (href) => {
  return (e) => {
    e.stopPropagation()
    window.open(href ?? '', '_blank')
  }
}
